import { render } from "./HomeView.vue?vue&type=template&id=1ac8a8d0"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shaunbarratt/projects/uni/testing/shu-trampoline/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__